export default __webpack_public_path__ + "static/media/bank.icon.fe069e37.svg";